import { useMemo } from 'react'
import { isPulseDemoEnabled } from '@/config/env/pulseDemo'
import { DEMO_TEMPLATES } from '@/data/pulseDemo/demoTemplates'
import { buildDemoSchedules } from './buildDemoSchedules'
import { buildDemoSkills } from './buildDemoSkills'
import { buildDemoTriggers } from './buildDemoTriggers'
import { buildDemoUpdates } from './buildDemoUpdates'
import { usePulseDemoStore } from './pulseDemoStore'

// Each hook selects raw slices (stable until they change) and derives the list
// in useMemo — a selector that built the list itself would loop under Zustand 5.
const NONE = []
const gated = (build) => (isPulseDemoEnabled() ? build() : NONE)

export function useDemoSchedules() {
  const overrides = usePulseDemoStore((s) => s.overrides)
  const runs = usePulseDemoStore((s) => s.runs)
  return useMemo(() => gated(() => buildDemoSchedules({ overrides, runs })), [overrides, runs])
}

export function useDemoTriggers() {
  const overrides = usePulseDemoStore((s) => s.overrides)
  return useMemo(() => gated(() => buildDemoTriggers({ overrides })), [overrides])
}

export function useDemoSkills() {
  const overrides = usePulseDemoStore((s) => s.overrides)
  const addedSkillIds = usePulseDemoStore((s) => s.addedSkillIds)
  return useMemo(() => gated(() => buildDemoSkills({ overrides, addedSkillIds })), [overrides, addedSkillIds])
}

export function useDemoUpdates() {
  const overrides = usePulseDemoStore((s) => s.overrides)
  const runs = usePulseDemoStore((s) => s.runs)
  const readUpdateIds = usePulseDemoStore((s) => s.readUpdateIds)
  return useMemo(
    () => gated(() => buildDemoUpdates({ overrides, runs, readUpdateIds })),
    [overrides, runs, readUpdateIds],
  )
}

/** @param {'schedules' | 'triggers' | 'skills'} page */
export function useDemoTemplates(page) {
  return useMemo(() => gated(() => DEMO_TEMPLATES.filter((template) => template.page === page)), [page])
}
